import {
	AUTH_LOGOUT
} from "./types";

const addMessage = (state, message) => {
	state.recentMessages.unshift(message);
};

const addTlsCase = (state, tlsCase) => {
	const { recentTlsCases } = state;
	const index = recentTlsCases.findIndex((e) => e.id === tlsCase.id);
  
	if (index === -1) {
		recentTlsCases.unshift(tlsCase);
		state.recentTlsCases = recentTlsCases.slice(0, 3);
	}
};

const addServiceTlsCase = (state, request) => {
	const { recentServiceTlsCases } = state;
	const index = recentServiceTlsCases.findIndex((e) => e.id === request.id);
  
	if (index === -1) {
		recentServiceTlsCases.unshift(request);
		state.recentServiceTlsCases = recentServiceTlsCases.slice(0, 3);
	}
};

const ping = (state, status) => {
	state.status = status;
};

const setUser = (state, user) => {
	state.user 				 = user;
	state.lastSignedAt = new Date;
};

const addGroup = (state, group) => {
	const { recentGroups } = state;
	const index = recentGroups.findIndex((e) => e.id === group.id);

	if (index === -1) {
		recentGroups.unshift(group);
		state.recentGroups = recentGroups.slice(0, 3);
	}
};

const addToken = (state, token) => {
	state.token = token;
};

const signOut = (state) => {
	state.token = null;
};

export const mutations = {
	[AUTH_LOGOUT]: signOut,
	addMessage,
	ping,
	setUser,
	addGroup,
	addToken,
	addTlsCase,
	addServiceTlsCase
};